import { useContext, useEffect } from 'react';
import { InstantSearch, Configure, useInstantSearch } from 'react-instantsearch';
import { GlobalContext } from '../context/GlobalContext';
import algoliasearch from 'algoliasearch/lite';

import Loader from '../components/Loader/Loader';
import Subsidy from '../components/Subsidy/Subsidy';
import ProductDetails from '../components/Products/ProductDetails/ProductDetails';
import HookLoader from '../portlet/HookLoader/HookLoader';

import { DEV, PREPROD, SIT } from '../Constants';
import { createTransactionID } from '../Utils/createTransaction';

import './DeviceDetailsManager.scss';

const win: any = window;

const StateResults = () => {
    const { results } = useInstantSearch()
    const nbHits = results && results.nbHits;

    return (
        <>
            {nbHits > 0 ? (
                <ProductDetails hits={results?.hits} />
            ) : (
                <HookLoader loading={nbHits > 0 ? false : true} />
            )}
        </>
    )
};

const searchClient = algoliasearch('A47E3BWDPH', 'e5c93dfd73b094a9553e9a07349b774e');

function DeviceDetailsManager() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { seriesId, pageToDisplay } = state;
    const env = win["env_variable"];
    let indexName = '';

    useEffect(() => {
        const xcoid = createTransactionID(true);;
        !!!win["x-co-id"] && (win["x-co-id"] = xcoid);
        dispatch({ type: 'XCOID', payload: { xcoid } });
    }, []);

    if (env.toUpperCase() === DEV) {
        indexName = "BM_Test_EN_AR_Series_Variants"; // update later
    } else if (env.toUpperCase() === SIT) {
        indexName = "BM_Test_EN_AR_Series_Variants"; // update later
    } else if (env.toUpperCase() === PREPROD) {
        indexName = "preprod_devices_variants";
    } else {
        indexName = "prod_devices_variants";
    }

    return (
        <>
            <Loader />
            {pageToDisplay === 'ProductDetails' && (
                <InstantSearch indexName={indexName} searchClient={searchClient}>
                    <Configure hitsPerPage={32} filters={`category.id:${seriesId}`} />
                    <StateResults />
                </InstantSearch>
            )}

            {pageToDisplay === 'Subsidy' && <Subsidy />}
        </>
    )
}

export default DeviceDetailsManager;